import React from 'react';
import { FaBrain, FaBaby, FaHeartbeat, FaFemale, FaCalendarAlt, FaPhoneAlt, FaStar, FaCheck, FaUserMd, FaHospital, FaStethoscope, FaHandsHelping } from 'react-icons/fa';
import '../style.css';

const AboutUs = () => {
  return (
    <div className="about-rockland">
      
      {/* Hero Section - Left Text, Right Image */}
      <section className="hero-section light-blue-bg">
        <div className="container">
          <div className="hero-grid">
            <div className="hero-content">
              <h1>About Rockland</h1>
              <h2>All-in-One Healthcare for Brain, Mothers & Children</h2>
              <p>
                At Rockland, we care for what matters most—your mind, your motherhood, 
                and your little ones. With decades of experience, we provide expert 
                care in neurology, maternity, and child health.
              </p>
              
            </div>
            
            <div className="hero-image">
              <div className="image-frame round-corner">
                <img src="image5.png " alt="Rockland Clinic" />
                <div className="image-overlay">
                  <h4>Advanced Medical Facility</h4>
                  <p>State-of-the-art equipment & technology</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Services Section - Alternating Layout */}
      <section className="services-section light-orange-bg">
        <div className="container">
          <div className="section-header">
            <h2>Our Comprehensive Services</h2>
            <p>Expert care across multiple specialties</p>
          </div>
          
          <div className="services-grid">
            {/* Service 1 - Left Image, Right Text */}
            <div className="service-row">
              <div className="service-image left-image">
                <div className="image-card oval-frame">
                  <img src="/image2.png" alt="Neurology Services" />
                </div>
              </div>
              <div className="service-content">
                <div className="service-icon blue-icon">
                  <FaBrain />
                </div>
                <h3>Advanced Neurological Diagnosis & Treatment</h3>
                <p>State-of-the-art neurological care with advanced diagnostic tools and treatment methods for brain and spine conditions.</p>
                <ul className="service-features">
                  <li><FaCheck /> Brain & Spine Surgery</li>
                  <li><FaCheck /> Neuro Rehabilitation</li>
                  <li><FaCheck /> Stroke Management</li>
                </ul>
              </div>
            </div>

            {/* Service 2 - Right Image, Left Text */}
            <div className="service-row reverse">
              <div className="service-content">
                <div className="service-icon pink-icon">
                  <FaBaby />
                </div>
                <h3>Safe & Supportive Pregnancy Care</h3>
                <p>Comprehensive maternity services with personalized care plans for expecting mothers, ensuring safe delivery and postpartum care.</p>
                <ul className="service-features">
                  <li><FaCheck /> Prenatal Monitoring</li>
                  <li><FaCheck /> Labor & Delivery</li>
                  <li><FaCheck /> Postnatal Care</li>
                </ul>
              </div>
              <div className="service-image right-image">
                <div className="image-card square-frame">
                  <img src="/image3.png" alt="Maternity Care" />
                </div>
              </div>
            </div>

            {/* Service 3 - Left Image, Right Text */}
            <div className="service-row">
              <div className="service-image left-image">
                <div className="image-card diamond-frame">
                  <img src="https://rocklandclinic.com/wp-content/uploads/2025/04/1-640x450.jpg" alt="Pediatric Care" />
                </div>
              </div>
              <div className="service-content">
                <div className="service-icon green-icon">
                  <FaHeartbeat />
                </div>
                <h3>Friendly & Complete Pediatric Services</h3>
                <p>Specialized pediatric care for children of all ages in a child-friendly environment with expert pediatricians.</p>
                <ul className="service-features">
                  <li><FaCheck /> Child Wellness Checkups</li>
                  <li><FaCheck /> Vaccination Programs</li>
                  <li><FaCheck /> Pediatric Emergencies</li>
                </ul>
              </div>
            </div>

            {/* Service 4 - Right Image, Left Text */}
            <div className="service-row reverse">
              <div className="service-content">
                <div className="service-icon purple-icon">
                  <FaFemale />
                </div>
                <h3>Compassionate Senior & Women's Health</h3>
                <p>Dedicated care for seniors and comprehensive women's health services focusing on wellness and specialized treatment.</p>
                <ul className="service-features">
                  <li><FaCheck /> Geriatric Care</li>
                  <li><FaCheck /> Women's Wellness</li>
                  <li><FaCheck /> Preventive Health</li>
                </ul>
              </div>
              <div className="service-image right-image">
                <div className="image-card circle-frame">
                  <img src="https://cartercountyhealth.org/wp-content/uploads/2022/09/mature-lady-preparing-to-get-vaccinated-against-co-2022-01-19-00-11-06-utc-1.jpg" alt="Senior Care" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Neurosurgeon Excellence - Split Layout */}
      <section className="neuro-section light-blue-bg">
        <div className="container">
          <div className="neuro-grid">
            <div className="neuro-content">
              <h2>Top Neurosurgeon in Varanasi | Rockland</h2>
              <h3>Advanced Neurosurgery & Neurology Care</h3>
              <p>
                Our neurology department is led by some of the best neurosurgeons in Varanasi, 
                equipped with advanced technology for complex brain and spine surgeries.
              </p>
              
              <div className="neuro-features">
                <div className="neuro-feature">
                  <FaStar className="feature-icon" />
                  <div>
                    <h5>Brain Tumor Surgery</h5>
                    <p>Minimally invasive procedures</p>
                  </div>
                </div>
                <div className="neuro-feature">
                  <FaStar className="feature-icon" />
                  <div>
                    <h5>Spine Surgery</h5>
                    <p>Advanced spinal treatments</p>
                  </div>
                </div>
                <div className="neuro-feature">
                  <FaStar className="feature-icon" />
                  <div>
                    <h5>Stroke Care</h5>
                    <p>24/7 emergency stroke unit</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="neuro-image">
              <div className="doctor-card">
                <div className="doctor-image">
                  <img src="image4.png" alt="Neurosurgeon" />
                </div>
                <div className="doctor-info">
                  <h4>Our Neurosurgeon Team</h4>
                  <p>Experienced specialists with 15+ years in neurosurgery</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How We Help - Centered Content */}
      <section className="help-section light-orange-bg">
        <div className="container">
          <div className="help-content">
            <h2>How Can We Help</h2>
            <h3>Compassionate, Flexible & Responsive Care for Every Stage of Life</h3>
            <p className="help-description">
              At Rockland, we understand that health needs can change quickly—whether it's 
              a sudden neurological concern, prenatal care, or pediatric support. That's 
              why we deliver care that adapts with you. Our multidisciplinary team is 
              equipped to support patients of all ages with empathy, speed, and precision.
            </p>
            
          </div>
        </div>
      </section>

      {/* Final CTA - Bottom Section */}
      <section className="cta-section light-blue-bg">
        <div className="container">
          <div className="cta-content">
            <div className="cta-text">
              <h3>Ready to Experience Exceptional Care?</h3>
              <p>Book your appointment today and take the first step towards better health</p>
            </div>
            
            <div className="cta-buttons">
              <button className="appointment-btn-small">
                <FaCalendarAlt /> Make Appointment
              </button>
              <button className="call-btn-small">
                <FaPhoneAlt /> Call Now
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;